module.exports = __webpack_public_path__ + "static/media/slogan.fe6b826c.jpg";